// custom-cart-drawer.js
const popupContainers = document.querySelectorAll(".hover-popup-container");

popupContainers.forEach((container) => {
  const img2 = container.querySelector("img");
  const popup = container.querySelector(".hover-popup-text");
  let isOpen = false;
  img2.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    isOpen = !isOpen;

    // Log for debugging
    console.log("Image clicked, isOpen:", isOpen);

    if (isOpen) {
      popup.classList.add("show");
    } else {
      popup.classList.remove("show");
    }

    // Log current classes
    console.log("Current popup classes:", popup.classList);
  });

  document.addEventListener("click", (e) => {
    if (!container.contains(e.target)) {
      isOpen = false;
      popup.classList.remove("show");
    }
  });
});
const addToCart = async (formData, showNotification = true) => {
  // console.log('the data recived is:', formData);
  try {
    // Parse the form data to extract variant ID and quantity
    const formDataObject = Object.fromEntries(formData.entries());
    const variantId = formDataObject.id;
    const quantity = formDataObject.quantity || 1;
    // console.log('the variantId is:', variantId);

    // Retrieve subscription plan and selling plans from local storage
    const subscriptionPlan = localStorage.getItem("subscriptionPlan");
    const storedPlans =
      JSON.parse(localStorage.getItem("productVariantSellingPlans")) || [];

    // Find the corresponding variant's selling plans
    const variantSellingPlans =
      storedPlans.find((plan) => plan.variantId === variantId)
        ?.sellingPlanIds || [];

    // Determine the selling plan ID based on the subscription type
    let sellingPlanId = null;

    console.log("called subscriptionPlan:", subscriptionPlan);

    if (subscriptionPlan === "monthly") {
      sellingPlanId = variantSellingPlans[0] || null; // Use the first selling plan
    } else if (subscriptionPlan === "weekly") {
      sellingPlanId = variantSellingPlans[1] || null; // Use the second selling plan
    } else if (subscriptionPlan === "biweekly") {
      sellingPlanId = variantSellingPlans[2] || null;
    }

    // Prepare data for the add-to-cart request
    const cartData = {
      id: variantId,
      quantity: parseInt(quantity, 10),
    };

    // If a selling plan ID is applicable, include it in the cart data
    if (sellingPlanId) {
      console.log(
        `Added product with ${subscriptionPlan} and selling_plan ${sellingPlanId}`
      );
      cartData.selling_plan = sellingPlanId;
    } else {
      console.log("added without selling plan");
    }

    // Convert cart data to FormData
    const cartFormData = new FormData();
    for (const [key, value] of Object.entries(cartData)) {
      cartFormData.append(key, value);
    }

    // Send the add-to-cart request
    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: cartFormData,
    });

    if (!response.ok) throw new Error("Add to cart failed");

    const data = await response.json();

    // Dispatch a custom event for the added item
    const productName = data.title || data.product_title || "Product";
    const productImage =
      data.image ||
      (data.featured_image && data.featured_image.url) ||
      "/path/to/default/image.jpg";

    const event = new CustomEvent("cart:added", {
      detail: {
        name: productName,
        image: productImage,
      },
    });
    if (showNotification) document.dispatchEvent(event);

    // Update prices after adding to cart
    onCartPriceUpdate();

    return data;
  } catch (error) {
    console.error("Error in addToCart:", error);
    // Handle fetch error
    handleFetchError(error);
  }
};

export default addToCart;

// Function to get cart data
const getCartData = async () => {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart");
    return await response.json();
  } catch (error) {
    handleFetchError(error);
  }
};

const updateCartDrawer = async () => {
  try {
    const cartDrawerResponse = await fetch("/?section_id=custom-cart-drawer");
    const text = await cartDrawerResponse.text();

    const html = document.createElement("div");
    html.innerHTML = text;

    // Extract the cart drawer content
    const newCartDrawerContent = html.querySelector(
      "#custom-cart-drawer"
    ).innerHTML;

    const existingDrawer = document.querySelector("#custom-cart-drawer");
    if (existingDrawer) {
      existingDrawer.innerHTML = newCartDrawerContent;
      console.log("Cart drawer updated");

      initializeQuantityHandlers();
      initializeCartDrawer();
      updateNavbarCartCount();
      // Reinitialize subscription state and event listeners
      reinitializeSubscriptionState();
      initializeDatePicker();
      updateDate();
      attachListener();
    } else {
      console.error("Existing cart drawer element not found");
    }
  } catch (error) {
    console.error("Error updating cart drawer:", error);
    handleFetchError(error);
  }
};

// REPLACE your updateCartPrices function with this corrected version:

async function updateCartPrices() {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart");
    const cart = await response.json();

    // Check if subscription checkbox is enabled AND cart has subscription products
    const isSubscriptionEnabled =
      SubscriptionStateManager.getSubscriptionCheckboxState();
    const hasSubscriptionProducts = cart.items.some(
      (item) => item.selling_plan_allocation !== null
    );

    // Only apply subscription pricing if BOTH conditions are true
    const shouldApplySubscriptionPricing =
      isSubscriptionEnabled && hasSubscriptionProducts;

    // Update pricing elements based on subscription status
    const itemTotalElement = document.getElementById("item-total-price");
    const totalSavingsElement = document.getElementById("total-savings");
    const grandTotalElement = document.getElementById("grand-total-price");

    if (itemTotalElement && totalSavingsElement && grandTotalElement) {
      const originalTotal = cart.original_total_price / 100; // Convert from cents

      if (shouldApplySubscriptionPricing) {
        // For subscription products: Show inflated price with 10% "savings"
        const inflatedTotal = originalTotal * 1.1; // Add 10% to original price
        const savingsAmount = inflatedTotal - originalTotal; // This will be 10% of original

        // Update Item Total (show original price + 10%)
        itemTotalElement.textContent = `RM${inflatedTotal.toFixed(2)}`;

        // Update Total Savings (show 10% savings)
        totalSavingsElement.textContent = `(-)RM${savingsAmount.toFixed(2)}`;

        // Update Grand Total (show original price - customer pays original price)
        grandTotalElement.textContent = `RM${originalTotal.toFixed(2)}`;

        console.log(
          `Subscription pricing: Item ${inflatedTotal.toFixed(2)}, Savings ${savingsAmount.toFixed(
            2
          )}, Final ${originalTotal.toFixed(2)}`
        );
      } else {
        // No subscription pricing - show regular pricing
        const actualSavings =
          (cart.original_total_price - cart.total_price) / 100;
        const finalTotal = cart.total_price / 100;

        itemTotalElement.textContent = `RM${originalTotal.toFixed(2)}`;
        totalSavingsElement.textContent = `(-)RM${actualSavings.toFixed(2)}`;
        grandTotalElement.textContent = `RM${finalTotal.toFixed(2)}`;

        console.log(
          `Regular pricing: Item ${originalTotal.toFixed(2)}, Savings ${actualSavings.toFixed(
            2
          )}, Final ${finalTotal.toFixed(2)}`
        );
      }
    }

    // Also update other cart price elements (keeping your existing logic)
    const totalPriceElements = document.querySelectorAll(
      ".original-total:not(#item-total-price), [data-cart-total], .cart-total-price"
    );
    totalPriceElements.forEach((element) => {
      if (element) {
        const formattedPrice = (cart.original_total_price / 100).toFixed(2);
        element.textContent = formattedPrice;
      }
    });

    // Update subtotal if exists
    const subtotalElements = document.querySelectorAll(
      ".cart-subtotal, [data-cart-subtotal]"
    );
    subtotalElements.forEach((element) => {
      if (element) {
        const formattedSubtotal = (cart.total_price / 100).toFixed(2);
        element.textContent = formattedSubtotal;
      }
    });

    console.log(
      "Cart prices updated successfully",
      shouldApplySubscriptionPricing
        ? "with subscription discount display"
        : "without subscription pricing"
    );
  } catch (error) {
    console.error("Error updating cart prices:", error);
  }
}

// Enhanced function to trigger price updates after cart operations
function onCartPriceUpdate() {
  updateCartPrices();
}

// Enhanced cart drawer update with price refresh
const updateCartDrawerWithPrices = async () => {
  await updateCartDrawer();
  onCartPriceUpdate();
};

// New function to reinitialize subscription state and event listeners
const reinitializeSubscriptionState = () => {
  // Reattach event listeners for subscription buttons
  document
    .getElementById("monthlySubscription")
    ?.addEventListener("click", () => {
      handleButtonClick("monthly");
    });

  document
    .getElementById("weeklySubscription")
    ?.addEventListener("click", () => {
      handleButtonClick("weekly");
    });

  document
    .getElementById("biweeklySubscription")
    ?.addEventListener("click", async () => {
      handleButtonClick("biweekly");
    });

  document
    .getElementById("mondaySubscription")
    ?.addEventListener("click", async () => {
      handleButtonClickToAdd("monday");
    });
  document
    .getElementById("thursdaySubscription")
    ?.addEventListener("click", async () => {
      handleButtonClickToAdd("thursday");
    });

  // Reattach checkbox change event listener
  const toggleCheckbox = document.getElementById("toggleCheckbox");
  if (toggleCheckbox) {
    // Remove existing listeners to prevent duplicates
    toggleCheckbox.removeEventListener("change", checkboxChangeHandler);
    toggleCheckbox.addEventListener("change", checkboxChangeHandler);
  }

  // Restore saved subscription state
  const savedPlan = SubscriptionStateManager.getCurrentPlan();
  const savedDay = SubscriptionStateManager.getCurrentDay();
  if (savedPlan && savedDay) {
    SubscriptionStateManager.updateButtonStyles(savedPlan, savedDay);
  }

  const savedCheckboxState =
    SubscriptionStateManager.getSubscriptionCheckboxState();
  SubscriptionStateManager.updateCheckboxState(savedCheckboxState);
};

// Separate handler for checkbox to allow removal and re-adding
const checkboxChangeHandler = async (event) => {
  const isChecked = event.target.checked;
  const subscriptionButtons = document.getElementById("subscriptionButtons");

  // Update state
  SubscriptionStateManager.setSubscriptionCheckboxState(isChecked);

  if (isChecked) {
    // Fetch cart items and selling plans when the checkbox is clicked
    const cartItems = await fetchCartItems();
    const variantIds = cartItems.map((item) => item.variantId);
    await fetchSellingPlans(variantIds);
  } else {
    //Hide the date picker when Subscription check box is unchecked
    // document.getElementById('startDatePickerWrapper')?.classList.add('hide-date-picker');

    showLoader();

    // Update state
    SubscriptionStateManager.setCurrentPlan("", "");

    // Step 1: Fetch items from the cart
    const cartItems = await fetchCartItems();

    // Step 2: Clear the cart
    await clearCart();

    // Step 3: Add items back without any selling plan
    for (const item of cartItems) {
      await addToCartsub(item.variantId, item.quantity);
    }

    console.log("All items re-added to the cart without selling plans.");
    await updateCartDrawerWithPrices();

    hideLoader();
  }
};

// Function to toggle the cart drawer's visibility
const toggleCartDrawer = (show = true) => {
  const drawer = document.getElementById("custom-cart-drawer");
  if (!drawer) {
    console.error("Cart drawer element not found");
    return;
  }

  if (show) {
    drawer.classList.remove("hidden");
    setTimeout(() => drawer.classList.add("active"), 10);
    document.body.style.overflow = "hidden";
  } else {
    drawer.classList.remove("active");
    setTimeout(() => drawer.classList.add("hidden"), 300);
    document.body.style.overflow = "";
  }
};

// Function to handle quantity changes
const handleQuantityChange = async (itemId, newQuantity) => {
  try {
    // console.log('Updating quantity for item ID:', itemId, 'New quantity:', newQuantity);
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemId,
        quantity: newQuantity,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        status: response.status,
        message: errorData.message || errorData.description,
      };
    }
    const data = await response.json();
    // Find the product from the cart object
    const updatedItem = data.items.find((item) => item.key === itemId);
    // Get the updated quantity
    const quantity = updatedItem ? updatedItem.quantity : null;

    // If product is there - pass product id else cart item id
    const id = updatedItem ? updatedItem.id : itemId;

    // Dispatch the event : Listener is setup in custom-cart-submission.js
    const event = new CustomEvent("quantityUpdated", {
      detail: {
        data: {
          id,
          quantity,
        },
      },
    });

    document.dispatchEvent(event);

    await updateCartDrawer();
    onCartPriceUpdate();

    return true;
  } catch (error) {
    handleFetchError(error);
  }
};

// Function to handle quantity input changes
const handleQuantityInput = async (input) => {
  const cartItem = input.closest(".cart-item");
  if (!cartItem) {
    console.error("Cart item container not found for quantity input");
    return;
  }

  const itemId = cartItem.dataset.id;
  let newQuantity = parseInt(input.value);

  if (isNaN(newQuantity) || newQuantity < 1) {
    input.value = 1;
    return;
  }

  let isQuantityExceeded = false;
  if (newQuantity > 9) {
    newQuantity = 9;
    isQuantityExceeded = true;
  }

  try {
    const response = await handleQuantityChange(itemId, newQuantity);
    toggleQuantityAlert(response, itemId, isQuantityExceeded);
  } catch (error) {
    console.error("Failed to update quantity:", error);
  }
};

// Function to update navbar's cart count
const updateNavbarCartCount = async () => {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart data");
    const cart = await response.json();

    // Update ALL cart count badges
    const cartCountElements = document.querySelectorAll(".cart-count-badge");

    cartCountElements.forEach((element) => {
      if (cart.item_count > 0) {
        element.textContent = cart.item_count;
        element.classList.remove("hidden");
      } else {
        element.classList.add("hidden");
      }
    });
  } catch (error) {
    console.error("Error updating navbar cart count:", error);
  }
};

// Function to show add-to-cart notifications
const showAddToCartNotification = (name, image) => {
  const body = document.body;

  const existingNotification = body.querySelector(".add-to-cart-notification");
  if (existingNotification) {
    console.log("Notification already exists");
    existingNotification.remove();
  }

  // <h4 class="font-roca  text-black">Congratulations!</h4>
  const notificationHTML = `
    <div class="add-to-cart-notification" role="alert" aria-live="assertive">
      <img src="${image}" alt="${name}" class="notification-image">
      <div class="text-holder">
        
        <span class="notification-text tracking-normal font-normal font-dmsans text-black opacity-60">${name} added to cart.</span>
      </div>
      <button class="notification-close-btn" aria-label="Close Notification">&times;</button>
    </div>
  `;

  body.insertAdjacentHTML("beforeend", notificationHTML);

  const notification = body.querySelector(".add-to-cart-notification");
  const closeButton = notification.querySelector(".notification-close-btn");

  void notification.offsetWidth; // Trigger reflow

  notification.classList.add("show");

  closeButton.addEventListener("click", () => {
    hideAddToCartNotification();
  });

  setTimeout(() => hideAddToCartNotification(), 2000);
};

// Function to hide add-to-cart notifications
const hideAddToCartNotification = () => {
  const notification = document.querySelector(".add-to-cart-notification");
  if (notification) {
    notification.classList.remove("show");
    setTimeout(() => {
      notification.remove();
    }, 300);
  }
};

// Listen for 'cart:added' Event
document.addEventListener("cart:added", (e) => {
  const { name, image } = e.detail; // Correctly extract from e.detail
  showAddToCartNotification(name, image);
  // toggleCartDrawer(true);
  // console.log('togglecart');
});

// Function to initialize quantity handlers
const initializeQuantityHandlers = () => {
  const cartItems = document.querySelector(".cart-items");
  if (!cartItems) {
    console.log("Cart items container not found");
    return;
  }

  // Remove existing event listeners to prevent duplication
  const newCartItems = cartItems.cloneNode(true);
  cartItems.parentNode.replaceChild(newCartItems, cartItems);

  // Handle click events for quantity buttons
  newCartItems.addEventListener("click", async (e) => {
    console.log("Click event detected on cart items");
    const cartItem = e.target.closest(".cart-item");
    if (!cartItem) {
      console.log("No cart item found");
      return;
    }

    const itemId = cartItem.dataset.id;
    console.log("Item ID:", itemId);
    const quantityInput = cartItem.querySelector('input[type="number"]');
    if (!quantityInput) {
      console.log("Quantity input not found for item:", itemId);
      return;
    }
    // Disable the quantity buttons till api call
    if (
      e.target.classList.contains("quantity-decrease") ||
      e.target.classList.contains("quantity-increase")
    ) {
      cartItem.querySelectorAll(".cart-item__quantity").forEach((btn) => {
        btn.classList.add("custom-disable");
      });
    }

    let currentQuantity = parseInt(quantityInput.value);

    try {
      if (e.target.classList.contains("quantity-decrease")) {
        if (currentQuantity === 1) {
          await handleQuantityChange(itemId, 0);
          onCartPriceUpdate();
        } else {
          const newQuantity = currentQuantity - 1;
          quantityInput.value = newQuantity;
          await handleQuantityChange(itemId, newQuantity);
        }
      } else if (e.target.classList.contains("quantity-increase")) {
        const newQuantity = currentQuantity + 1;
        if (newQuantity === 10) {
          toggleQuantityAlert("null", itemId, true);
          return;
        }
        quantityInput.value = newQuantity;
        const response = await handleQuantityChange(itemId, newQuantity);
        toggleQuantityAlert(response, itemId);
      }
    } catch (error) {
      console.error("Error handling quantity change:", error);
    } finally {
      // cartItem.querySelectorAll('.cart-item__quantity').forEach((btn) => {
      //   btn.classList.remove('custom-disable');
      // });
    }
  });

  newCartItems.addEventListener("change", async (e) => {
    if (e.target.matches('input[type="number"]')) {
      console.log("Quantity input changed");
      await handleQuantityInput(e.target);
    }
  });
};

// Function to toggle  quantity unavailable alertbox
async function toggleQuantityAlert(response, itemId, limitExceeded = false) {
  if (response !== true) await updateCartDrawer();
  // Get the fresh dom reference to the cartItem
  const cartItem = document.querySelector(`div[data-id="${itemId}"]`);
  const alertTextElement = cartItem.querySelector("#quantity-unavailable");
  const wrapper = cartItem.querySelector(".unavailable");

  // 1. First error for Unavailable quantity while adding through quantity button

  // Status 422 is for stock and quantity error (Limited stock)
  if (response && response.status === 422) {
    // Disable the increase button
    cartItem.querySelectorAll(".quantity-increase").forEach((btn) => {
      btn.disabled = true;
      btn.classList.add("custom-disable");
    });

    // Set error message in quantity-unavailable elements

    if (alertTextElement) {
      const match = response.message.match(/\d+/);
      if (match) {
        const quantity = parseInt(match[0]);
        const item = quantity > 1 ? "items" : "item";
        const msg = `${quantity} ${item} added (limited stock)`;
        alertTextElement.innerText = msg;
      } else {
        // Fallback if no number is found
        alertTextElement.innerText = "Items added (limited stock)";
      }
    }
    // Finally show the alert
    if (wrapper) wrapper.classList.remove("hide-me");
    return;
  }

  // 2. Second error for exceeding max limit while adding through input field
  if (limitExceeded) {
    // Disable all the increase buttons
    cartItem.querySelectorAll(".quantity-increase").forEach((btn) => {
      btn.disabled = true;
      btn.classList.add("custom-disable");
    });

    // Set error message in quantity-unavailable elements
    alertTextElement.innerText = "Max 9 items allowed";
    // Finally show the alert
    if (wrapper) wrapper.classList.remove("hide-me");
  }
}

// Function to initialize cart drawer functionality
const initializeCartDrawer = () => {
  const closeButton = document.querySelector(".custom-drawer__close");
  if (closeButton) {
    closeButton.addEventListener("click", () => toggleCartDrawer(false));
  } else {
    console.warn("Close button not found");
  }

  const overlay = document.querySelector(".custom-drawer__overlay");
  if (overlay) {
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        toggleCartDrawer(false);
      }
    });
  } else {
    console.warn("Cart drawer overlay not found");
  }

  // Initialize remove item buttons if they exist
  document.querySelectorAll(".cart-item__remove").forEach((removeButton) => {
    removeButton.addEventListener("click", async (e) => {
      e.preventDefault();
      const cartItem = removeButton.closest(".cart-item");
      if (!cartItem) {
        console.log("Cart item not found for removal");
        return;
      }
      const itemId = cartItem.dataset.id;
      await handleQuantityChange(itemId, 0);
    });
  });
};

const handleFetchError = (error) => {
  console.error("Fetch error:", error);
};

const initializeCartCountOnLoad = async () => {
  await updateNavbarCartCount();
};

function initializeCart() {
  initializeDatePicker();
  // initCartObserver();
  updateDate();
  attachListener();

  document.querySelectorAll(".product-card").forEach(function (product) {
    const addButton = product.querySelector(".add-to-cart-btn");
    const variantIdElement = product.querySelector(".variant-id");

    if (addButton && variantIdElement) {
      addButton.addEventListener("click", async function (e) {
        e.preventDefault();

        const variantIdText = parseInt(
          variantIdElement.dataset.variantId ||
            variantIdElement.textContent.trim()
        );
        if (isNaN(variantIdText)) {
          console.error("Invalid variant ID:", variantIdElement.textContent);
          return;
        }
        const quantity = 1;

        const formData = new FormData();
        formData.append("id", variantIdText);
        formData.append("quantity", quantity);

        try {
          await addToCart(formData);
          await updateCartDrawer();
          onCartPriceUpdate();
          toggleCartDrawer(true);
        } catch (error) {
          console.error("Failed to add to cart:", error);
        }
      });
    } else {
      // if (!addButton) console.warn('Add to cart button not found in product:', product);
      // if (!variantIdElement) console.warn('Variant ID element not found in product:', product);
    }
  });

  initializeQuantityHandlers();
  initializeCartDrawer();

  document.addEventListener("click", async (e) => {
    const plusButton = e.target.closest(".plus-button");
    if (!plusButton) return;

    e.preventDefault();
    e.stopPropagation();

    try {
      const productElement = plusButton.closest(".suggestion-items");
      if (!productElement) {
        throw new Error("Product element not found");
      }

      const variantIdElement = productElement.querySelector(".variant-id");
      if (!variantIdElement) {
        throw new Error("Variant ID element not found");
      }

      const variantId = parseInt(variantIdElement.dataset.variantId);
      if (isNaN(variantId)) {
        throw new Error("Invalid variant ID");
      }

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", "1");

      await addToCart(formData);
      await updateCartDrawer();
      onCartPriceUpdate();
      toggleCartDrawer(true);
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      alert("Failed to add item to cart. Please try again.");
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      toggleCartDrawer(false);
    }
  });

  initializeCartCountOnLoad();
}

window.addToCart = addToCart;
window.toggleCartDrawer = toggleCartDrawer;
window.updateCartDrawer = updateCartDrawer;
window.initializeCart = initializeCart;
window.updateNavbarCartCount = updateNavbarCartCount;
window.handleQuantityChange = handleQuantityChange;
window.updateCartPrices = updateCartPrices;
window.onCartPriceUpdate = onCartPriceUpdate;
window.updateCartDrawerWithPrices = updateCartDrawerWithPrices;

document.addEventListener("DOMContentLoaded", () => {
  initializeCart();

  // Update pricing on page load to show subscription discounts
  setTimeout(() => {
    updateCartPrices();
  }, 800);
});
window.addEventListener("load", () => {
  // Additional pricing update after page is fully loaded
  setTimeout(() => {
    updateCartPrices();
  }, 500);
});

// Helper to extract numeric IDs from Shopify GIDs
const extractNumericId = (gid) => gid.split("/").pop();

// Fetch Cart Items
const fetchCartItems = async () => {
  const response = await fetch("/cart.js");
  if (!response.ok) throw new Error("Failed to fetch cart items.");
  const cart = await response.json();
  console.log("Fetched Cart Items:", cart.items);
  return cart.items.map((item) => ({
    variantId: extractNumericId(
      `gid://shopify/ProductVariant/${item.variant_id}`
    ),
    quantity: item.quantity,
  }));
};

// Fetch Selling Plans for Variants
const fetchSellingPlans = async (variantIds) => {
  const query = `
      {
        nodes(ids: ${JSON.stringify(variantIds.map((id) => `gid://shopify/ProductVariant/${id}`))}) {
          ... on ProductVariant {
            id
            sellingPlanAllocations(first: 10) {
              edges {
                node {
                  sellingPlan {
                    id
                  }
                }
              }
            }
          }
        }
      }
    `;

  const response = await fetch(
    "https://meals-in-minutes-my.myshopify.com/api/2025-01/graphql",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "cc42e05b79959fc50b1b0eaac03e73fd",
      },
      body: JSON.stringify({ query }),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch selling plans.");
  }

  const result = await response.json();

  const sellingPlans = {};
  result.data.nodes.forEach((node) => {
    if (node && node.sellingPlanAllocations.edges.length > 0) {
      const variantId = extractNumericId(node.id);
      sellingPlans[variantId] = node.sellingPlanAllocations.edges.map((edge) =>
        extractNumericId(edge.node.sellingPlan.id)
      );
    }
  });

  return sellingPlans;
};

// Clear the Cart
const clearCart = async () => {
  const response = await fetch("/cart/clear.js", {
    method: "POST",
  });
  if (!response.ok) throw new Error("Failed to clear cart.");
  console.log("Cart Cleared");
};

// Add Items to Cart with Selling Plan IDs
const addToCartsub = async (variantId, quantity, sellingPlanId) => {
  const body = {
    id: variantId,
    quantity,
  };

  if (sellingPlanId) {
    body.selling_plan = sellingPlanId;
  }

  // The data should be in form-data format
  // const formData = new FormData();
  // formData.append('id', variantId);
  // formData.append('quantity', quantity);
  // if (sellingPlanId) formData.append('selling_plan', sellingPlanId);
  // if (selectedDay) formData.append('properties[_order-date]', selectedDay);
  // formData.append('form_type', 'product');

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Failed to add variant ${variantId} to cart.`);
  }

  console.log(
    `Added variant ${variantId} with selling plan ${sellingPlanId || "N/A"}`
  );
};

// Show loader
const showLoader = () => {
  document.getElementById("loaderContainer").style.display = "flex";
  document
    .getElementById("custom-cart-drawer")
    .classList.remove("overflow-y-scroll");
};

// Hide loader
const hideLoader = () => {
  document.getElementById("loaderContainer").style.display = "none";
  document
    .getElementById("custom-cart-drawer")
    .classList.add("overflow-y-scroll");
};

// Subscription State Management
const SubscriptionStateManager = {
  getCurrentPlan() {
    return localStorage.getItem("subscriptionPlan") || null;
  },

  getCurrentDay() {
    return localStorage.getItem("subscriptionDay") || null;
  },

  setCurrentPlan(plan, day) {
    localStorage.setItem("subscriptionPlan", plan);
    localStorage.setItem("subscriptionDay", day);
    this.updateButtonStyles(plan, day);
  },

  getSubscriptionCheckboxState() {
    return localStorage.getItem("subscriptionCheckbox") === "true";
  },

  setSubscriptionCheckboxState(isChecked) {
    localStorage.setItem("subscriptionCheckbox", isChecked);
    this.updateCheckboxState(isChecked);
  },

  updateButtonStyles(activePlan, activeDay) {
    const buttons = {
      biweekly: document.getElementById("biweeklySubscription"),
      weekly: document.getElementById("weeklySubscription"),
      monthly: document.getElementById("monthlySubscription"),
      monday: document.getElementById("mondaySubscription"),
      thursday: document.getElementById("thursdaySubscription"),
    };

    // Reset all button styles
    Object.values(buttons).forEach((btn) => {
      btn.classList.remove("bg-blue-500", "text-white", "active"); //Added Null check for safety
      btn.classList.add("border", "border-gray-300");
    });

    // Apply active style to selected button
    if (activePlan && buttons[activePlan]) {
      const activeButton = buttons[activePlan];
      activeButton.classList.remove("border", "border-gray-300");
      activeButton.classList.add("bg-blue-500", "text-white", "active");
    }

    if (activeDay && buttons[activeDay]) {
      const activeButton = buttons[activeDay];
      activeButton.classList.remove("border", "border-gray-300");
      activeButton.classList.add("bg-blue-500", "text-white", "active");
    }
  },

  updateCheckboxState(isChecked) {
    const checkbox = document.getElementById("toggleCheckbox");
    const subscriptionButtons = document.getElementById("subscriptionButtons");

    checkbox.checked = isChecked;
    subscriptionButtons.style.display = isChecked ? "flex" : "none";

    const datePickerWrapper = document.getElementById("datePickerWrapper");
    datePickerWrapper.style.display = isChecked ? "none" : "flex";
  },
};

function showCustomAlertBox(id) {
  const element = document.getElementById(id);
  if (element) {
    element.classList.remove("alert-hide"); // Unhide the alert box
    element.scrollIntoView({
      behavior: "smooth",
      block: "center", // This centers the element vertically
      inline: "nearest",
    });
  }
}

window.showCustomAlertBox = showCustomAlertBox;
window.showLoader = showLoader;
window.hideLoader = hideLoader;

//Function to add with selling plans only on Monday and Thursday buttons click
const handleButtonClickToAdd = async (planDay) => {
  // Call checkMinimumCartValue and exit early if it returns false
  document.getElementById("day")?.classList.add("alert-hide");

  const getPlan = SubscriptionStateManager.getCurrentPlan();

  if (!getPlan) {
    showCustomAlertBox("frequency");
    return;
  }

  if (typeof window.checkMinimumCartValue === "function") {
    const isValid = window.checkMinimumCartValue();
    if (!isValid) return; // Exit if minimum value not met
  }
  SubscriptionStateManager.setCurrentPlan(getPlan, planDay);
  SubscriptionStateManager.updateButtonStyles(getPlan, planDay);

  try {
    showLoader();
    // Step 1: Fetch items from the cart
    const cartItems = await fetchCartItems();

    // Step 2: Fetch selling plans for all variant IDs
    const variantIds = cartItems.map((item) => item.variantId);
    const sellingPlans = await fetchSellingPlans(variantIds);

    // Step 3: Clear the cart
    await clearCart();
    // // Step 4: Add items back with the appropriate selling plan
    for (const item of cartItems) {
      let sellingPlanId = null;

      if (getPlan === "monthly") {
        sellingPlanId = sellingPlans[item.variantId]
          ? sellingPlans[item.variantId][0]
          : null;
      } else if (getPlan === "weekly") {
        sellingPlanId = sellingPlans[item.variantId]
          ? sellingPlans[item.variantId][1]
          : null;
      } else if (getPlan === "biweekly") {
        sellingPlanId = sellingPlans[item.variantId]
          ? sellingPlans[item.variantId][2]
          : null;
      }

      await addToCartsub(item.variantId, item.quantity, sellingPlanId);
    }

    await addPreferredDay(planDay);

    console.log("All items re-added to the cart with selling plans.");
    await updateCartDrawerWithPrices(); // <-- ADD THIS LINE
    hideLoader();
  } catch (error) {
    console.error("Error:", error);
    hideLoader();
  }
};

// Handle Button Clicks (Monthly, Weekly, biweekly)
const handleButtonClick = async (planType) => {
  // Validate input
  if (!planType) {
    console.error("planType is required");
    return;
  }

  document.getElementById("frequency")?.classList.add("alert-hide");
  try {
    // Get current day before updating state
    const selectedDay = SubscriptionStateManager.getCurrentDay();

    // Update state with the selected day
    SubscriptionStateManager.setCurrentPlan(planType, selectedDay);

    console.log(`Handling button click for ${planType} subscription`);

    // Check if plan was added and we have a valid selected day
    if (selectedDay && selectedDay !== "null" && selectedDay.length > 0) {
      console.log("re-adding items with plan", planType);

      try {
        // Use the selectedDay we already have instead of calling getCurrentDay again
        await handleButtonClickToAdd(selectedDay);
      } catch (addError) {
        console.error("Error adding items with plan:", addError);
        // You might want to show user feedback here
        // or revert the plan state if needed
      }
    }
  } catch (error) {
    console.error("Error in handleButtonClick:", error);
    // Consider reverting state changes if needed
  }
};

async function addPreferredDay(day) {
  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "delivery-date": day.charAt(0).toUpperCase() + day.slice(1),
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to remove note: ${response.status}`);
    } else {
      localStorage.setItem("planAdded", "true");
    }

    return true;
  } catch (error) {
    console.error("Error removing date:", error);
    return false; // Let caller know it failed
  }
}

window.addPreferredDay = addPreferredDay;

// Show subscription buttons when checkbox is clicked
document
  .getElementById("toggleCheckbox")
  ?.addEventListener("change", async (event) => {
    const isChecked = event.target.checked;
    const subscriptionButtons = document.getElementById("subscriptionButtons");

    // Update state
    SubscriptionStateManager.setSubscriptionCheckboxState(isChecked);

    if (isChecked) {
      // Fetch cart items and selling plans when the checkbox is clicked
      const cartItems = await fetchCartItems();
      const variantIds = cartItems.map((item) => item.variantId);
      await fetchSellingPlans(variantIds);
    } else {
      showLoader();

      //Hide the date picker
      // document.getElementById('startDatePickerWrapper')?.classList.add('hide-date-picker');

      // Update state
      SubscriptionStateManager.setCurrentPlan("", "");

      // Step 1: Fetch items from the cart
      const cartItems = await fetchCartItems();

      // Step 2: Clear the cart
      await clearCart();

      // Step 3: Add items back without any selling plan
      for (const item of cartItems) {
        await addToCartsub(item.variantId, item.quantity);
      }

      console.log("All items re-added to the cart without selling plans.");
      await updateCartDrawerWithPrices();

      hideLoader();
    }
  });

// Bind Event Listeners for Buttons
document
  .getElementById("monthlySubscription")
  ?.addEventListener("click", () => {
    handleButtonClick("monthly");
  });

document.getElementById("weeklySubscription")?.addEventListener("click", () => {
  handleButtonClick("weekly");
});

document
  .getElementById("biweeklySubscription")
  ?.addEventListener("click", async () => {
    handleButtonClick("biweekly");
  });

document
  .getElementById("mondaySubscription")
  ?.addEventListener("click", async () => {
    handleButtonClickToAdd("monday"); // Only add to cart on this click
  });
document
  .getElementById("thursdaySubscription")
  ?.addEventListener("click", async () => {
    handleButtonClickToAdd("thursday"); // Only add to cart on this click
  });

// Initialize state on page load
const savedPlan = SubscriptionStateManager.getCurrentPlan();
const savedDay = SubscriptionStateManager.getCurrentDay();
if (savedPlan && savedDay) {
  SubscriptionStateManager.updateButtonStyles(savedPlan, savedDay);
}

const savedCheckboxState =
  SubscriptionStateManager.getSubscriptionCheckboxState();
SubscriptionStateManager.updateCheckboxState(savedCheckboxState);

console.log("All resources are fully loaded!");
console.log("Code executed after a delay!");
// Your delayed code here
function initializeDatePicker() {
  // console.log('Initializing date picker...');

  if (window.jQuery) {
    $(function () {
      const now = new Date();

      // Test times for debugging:
      // const now = new Date('2025-05-06T20:55:00'); // Tuesday 6th May at 8:55 PM (before cutoff)
      // const now = new Date('2025-05-06T21:30:00'); // Tuesday 6th May at 9:30 PM (after cutoff)
      // const now = new Date('2025-05-10T20:55:00'); // Saturday 10th May at 8:55 PM (before cutoff)
      // const now = new Date('2025-05-10T21:30:00'); // Saturday 10th May at 9:30 PM (after cutoff)

      function isValidDeliveryDate(date) {
        const day = date.getDay(); // 0=Sunday, 1=Monday, 2=Tuesday, 3=Wednesday, 4=Thursday, 5=Friday, 6=Saturday
        const month = date.getMonth(); // 0-indexed (0 = January, 11 = December)
        const dateDay = date.getDate();

        // Disable all dates before September 25th, 2025
        // const minDate = new Date(2025, 8, 25); // Month is 0-indexed, so 8 = September
        // const dateToCheck = new Date(
        //   date.getFullYear(),
        //   date.getMonth(),
        //   date.getDate()
        // );

        // if (dateToCheck < minDate) {
        //   return [false];
        // }

        // Disable Christmas and New Year dates
        if (
          (month === 11 && dateDay === 25) ||
          (month === 0 && dateDay === 1)
        ) {
          return [false];
        }

        // Disable Sundays
        if (day == 0) {
          return [false];
        }

        // Only allow Monday and Thursday
        // if (day !== 1 && day !== 4) {
        //   return [false];
        // }

        // Disable same day delivery
        if (
          date.getDate() === now.getDate() &&
          date.getMonth() === now.getMonth() &&
          date.getFullYear() === now.getFullYear()
        ) {
          return [false];
        }

        // Create a date object for comparison (without time)
        const deliveryDate = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate()
        );
        const today = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate()
        );

        // if (day === 4) {
        //   // Thursday delivery
        //   // Find the Tuesday before this Thursday
        //   const tuesdayBefore = new Date(deliveryDate);
        //   tuesdayBefore.setDate(deliveryDate.getDate() - 2); // Thursday - 2 days = Tuesday

        //   // Set Tuesday cutoff to 9 PM
        //   const tuesdayCutoff = new Date(
        //     tuesdayBefore.getFullYear(),
        //     tuesdayBefore.getMonth(),
        //     tuesdayBefore.getDate(),
        //     21,
        //     0,
        //     0,
        //     0
        //   );

        //   // If we're past Tuesday 9 PM, disable this Thursday
        //   if (now >= tuesdayCutoff) {
        //     return [false];
        //   }
        // }

        // if (day === 1) {
        //   // Monday delivery
        //   // Find the Saturday before this Monday
        //   const saturdayBefore = new Date(deliveryDate);
        //   saturdayBefore.setDate(deliveryDate.getDate() - 2); // Monday - 2 days = Saturday

        //   // Set Saturday cutoff to 9 PM
        //   const saturdayCutoff = new Date(
        //     saturdayBefore.getFullYear(),
        //     saturdayBefore.getMonth(),
        //     saturdayBefore.getDate(),
        //     21,
        //     0,
        //     0,
        //     0
        //   );

        //   // If we're past Saturday 9 PM, disable this Monday
        //   if (now >= saturdayCutoff) {
        //     return [false];
        //   }
        // }

        return [true]; // Valid delivery day
      }

      const $picker = $("#date-picker");

      if ($picker.length && !$picker.hasClass("hasDatepicker")) {
        $picker.datepicker({
          minDate: 0,
          changeYear: true,
          changeMonth: true,
          dateFormat: "dd/mm/yy",
          maxDate: "+5M",
          beforeShowDay: isValidDeliveryDate,
          beforeShow: function (input, inst) {
            setTimeout(function () {
              const $dp = $(inst.dpDiv);
              $(inst.dpDiv).appendTo("#insertDatepicker");
              $dp.css({
                position: "absolute",
                top: "3rem",
                display: "block",
                right: "0",
                left: "auto",
                zIndex: 9999,
              });
              // Add note if missing
              if (!$dp.find(".calendar-note").length) {
                $(
                  '<p class="calendar-note" style="font-size: 13px; margin-top: 8px; color: #555;">*We deliver every day excluding Sundays and public holidays</p>'
                ).appendTo($dp);
              }
            }, 0);
          },
          // This part ensures the note reappears on month/year change
          onChangeMonthYear: function (year, month, inst) {
            setTimeout(function () {
              const $dp = $(inst.dpDiv);
              if (!$dp.find(".calendar-note").length) {
                $(
                  '<p class="calendar-note" style="font-size: 13px; margin-top: 8px; color: #555;">*We deliver every day excluding Sundays and public holidays</p>'
                ).appendTo($dp);
              }
            }, 0);
          },
          onSelect: function (dateText, inst) {
            // Clear and update the innerText of the #dateInput element
            $("#dateInput").text(""); // Clear previous content
            $("#dateInput").text(dateText); // Set the selected date
            $("#date-alert").addClass("alert-hide");
            localStorage.setItem("selectedDate", dateText);
          },
          dayNamesMin: ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
        });
      }
    });
  }
}

function updateDate() {
  const selecteDate = localStorage.getItem("selectedDate");
  const datePicker = document.getElementById("date-picker");
  const insertDate = document.getElementById("dateInput");

  if (selecteDate && selecteDate !== "null" && datePicker && insertDate) {
    datePicker.value = selecteDate;
    insertDate.innerText = "";
    insertDate.innerText = selecteDate;
  }
}

function attachListener() {

  const closeBtn = document.querySelectorAll(".close-alert-box");
  closeBtn.forEach((btn) => {
    btn.addEventListener("click", () => {
      const parent = btn.closest(".custom-alert-box");
      if (parent) {
        parent.classList.add("alert-hide");
      } else {
        console.log("parent not found");
      }
    });
  });
}
